import { render, staticRenderFns } from "./ThePrice.vue?vue&type=template&id=bace7a88&scoped=true&"
import script from "./ThePrice.vue?vue&type=script&lang=js&"
export * from "./ThePrice.vue?vue&type=script&lang=js&"
import style0 from "./ThePrice.vue?vue&type=style&index=0&id=bace7a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bace7a88",
  null
  
)

export default component.exports